<script setup lang="ts">
import type { NuxtError } from '#app'
import crash from '~/assets/crash.png'

const props = defineProps({
  error: Object as () => NuxtError,
})

const handleError = () => clearError({ redirect: '/en' })
</script>

<template>
  <div class="grid h-screen w-screen place-content-center text-center p-2">
    <h2 class="font-brand text-4xl font-medium my-4">{{ error?.statusCode }}</h2>
    <p>{{ error?.statusMessage || 'Oops! Something went wrong...' }}</p>
    <p v-if="error?.message && error.statusCode !== 404" class="my-2 text-gray-600">
      {{ error.message }}
    </p>
    <img :src="crash" alt="Car Accident" class="max-w-[300px] mx-auto">
    <button @click="handleError" class="rounded-full mt-2 cursor-pointer border hover:bg-accent/10 border-accent py-2 px-3 text-sm mx-auto w-fit">
      Back Home
    </button>
  </div>
</template>
